export const TICKER_LOOKUP = {
    DASH: "Dash",
    OXT: "Orchid",
    ZRX: "0x",
    "1INCH": "1inch",
    DOGE: "Dogecoin",
    OGN: "Orgin",
    AAVE: "Aave",
    ENJ: "Enjin",
    DOT: "Polkadot",
    ALGO: "Algorand",
    MLN: "Enzyme",
    MATIC: "Polygon",
    AMP: "Amp",
    EOS: "EOS",
    QNT: "Quant",
    FORTH: "Ampleforth",
    ETH: "Ethereum",
    REN: "Ren",
    ANKR: "Ankr",
    ETC: "Ethereum Classic",
    SKL: "SKALE",
    BAL: "Balancer",
    FIL: "Filecoin",
    SOL: "Solana",
    BNT: "Bancor",
    GTC: "Gitcoin",
    XLM: "Stellar",
    BAND: "Band",
    RLC: "iExec",
    STORJ: "STORJ",
    BOND: "BarnBridge",
    ICP: "Internet Comp",
    SUSHI: "SushiSwap",
    BAT: "Basic Attention",
    KEEP: "Keep",
    SNX: "Synthetix",
    BTC: "Bitcoin",
    KNC: "Kyber",
    TRB: "Tellor",
    BCH: "Bitcoin cash",
    LPT: "Livepeer",
    USDT: "Tether",
    ADA: "Cardano",
    LTC: "Litecoin",
    XTZ: "Tezos",
    CTSI: "Cartesi",
    LOOM: "Loom",
    GRT: "Graph",
    CGLD: "Celo",
    LRC: "Loopring",
    UMA: "UMA",
    CHZ: "Chiliz",
    MIR: "Mirro",
    UNI: "Uniswap",
    COMP: "Compound",
    NKN: "NKN",
    USDC: "USD coin",
    ATOM: "Cosmos",
    NU: "NuCypher",
    WTBC: "Wrapped BTC",
    CRV: "Curve DAO",
    NMR: "Numeraire",
    YFI: "Yearn.finance",
    DAI: "Dai",
    OMG: "OMG",
    ZEC: "Zcash",
    SUI: "SUI"
};

export const SECURITIZE_CARD_STATUS = {
    NOT_STARTED: "Not Started",
    INCOMPLETE: "Incomplete",
    PENDING: "Pending",
    COMPLETE: "Complete",
};

export const SECURITIZE_CARD_INVESTMENT_RECOMMENDATION_INCOMPLETE = {
    title: "Investment Recommendation",
    content: SECURITIZE_CARD_STATUS.INCOMPLETE,
    clickable: true,
    contentColor: "red",
    backgroundColor: "white",
    showArrow: true,
}

export const SECURITIZE_CARD_INVESTMENT_RECOMMENDATION_COMPLETE = {
    title: "Investment Recommendation",
    content: SECURITIZE_CARD_STATUS.COMPLETE,
    clickable: false,
    contentColor: "green",
    backgroundColor: "white",
    showArrow: true,
}

export const ACCREDITATION_STATUS = {
    ACCREDITED: 'ACCREDITED',
    NOT_ACCREDITED: 'NOT_ACCREDITED',
    UNKNOWN: 'UNKNOWN',
};

export const CASH_RESERVE              = "CASH_RESERVE";
export const CASH_RESERVE_DISPLAY_NAME = "USD - Reserve";
export const USD_TEXT                  = "USD";
export const NUM_DECIMAL_PLACES_DONT_CARE = -1;

export const DEFAULT_NO_ORGANIZATION_ID = -1;

export const DISPLAY_FORMAT_TYPES = {
    DEFAULT: "DEFAULT",
    BRACKETS: "BRACKETS",
    BLANKABLE: "BLANKABLE",
    BLANKABLEDASH: "BLANKABLEDASH",
};

export const FORMAT_TYPES = {
    CURRENCY: "CURRENCY",
    PERCENT: "PERCENT",
    QUANTITY: "QUANTITY",
}

export const TRANSACTIONS_COLUMN_KEYS = [
    "transacted",
    "settled",
    "client_name",
    "account_id",
    "accountType",
    "account_groups",
    "firmName",
    "details",
    "type",
    "symbol",
    "quantity",
    "unitPrice",
    "amount",
    "custodian",
    "heldAway",
    "fee_amount",
    "action",
    "source",
    "taxTag",
    "taxYear",
    "tagStatus",
];

export const TRANSACTIONS_COLUMN_KEYS_TAX_TAGGING_DISABLED = [
    "transacted",
    "settled",
    "client_name",
    "account_id",
    "accountType",
    "account_groups",
    "firmName",
    "details",
    "type",
    "symbol",
    "quantity",
    "unitPrice",
    "amount",
    "custodian",
    "heldAway",
    "fee_amount",
    "action",
    "source",
];

export const TRANSACTIONS_COLUMN_KEYS_ACTION = 'action';

export const DEFAULT_LOADING_SPINNER = require("@/assets/animations/circle-loader.json");


//whitelabel constants
export const WHITELABEL_DEFAULT_LOGO = require("@/assets/whitelabel/default/logo.png");
export const WHITELABEL_DEFAULT_THUMBNAIL = require("@/assets/whitelabel/default/thumbnail.svg");


//account types
export const ACCOUNT_TYPES = {
    1: "Individual",
    2: "Trust",
    3: "Custodian",
    4: "Remittance",
    5: "JTWROS",
    6: "JTIC",
    7: "Roth IRA",
    8: "IRA",
    9: "Rollover IRA",
    10: "RIA",
    11: "Funding",
    12: "C Corp",
    13: "LLC",
    14: "LLP",
    15: "LP",
    16: "S Corp",
    17: "Sole Prop",
    18: "Non Profit",
    19: "Other",
}
export const GTC_CODE = 'GTC';
export const CUST_CODE = 'CUST';
export const TIME_IN_FORCE_OPTIONS = [
    { 'title': 'Good Till Cancelled', value: GTC_CODE },
    { 'title': 'Custom', value: CUST_CODE },
];
export const MARKET_ORDER_TYPE = 'market';
export const LIMIT_ORDER_TYPE = 'limit';
export const STOP_LOSS_ORDER_TYPE = 'stop_loss';
export const STOP_LIMIT_ORDER_TYPE = 'stop_limit';
export const TAKE_PROFIT_LIMIT_ORDER_TYPE = 'take_profit_limit';

export const ROTH_IRA = 7
export const IRA = 8
export const ROLLOVER_IRA = 9
export const BEN_ROTH_IRA = 33
export const BEN_IRA = 34
export const CONVERSION_ROTH_IRA = 35
export const ROLLOVER_ROTH_IRA = 36

export const ROTH_IRA_ACCOUNT_TYPES = [ROTH_IRA, BEN_ROTH_IRA, CONVERSION_ROTH_IRA, ROLLOVER_ROTH_IRA];
export const IRA_ACCOUNT_TYPES = [IRA, ROLLOVER_IRA, BEN_IRA];
export const ALL_IRA_ACCOUNT_TYPES = [...ROTH_IRA_ACCOUNT_TYPES, ...IRA_ACCOUNT_TYPES];

export const ROTH_IRA_TEXT = "Roth IRA";
export const IRA_TEXT = "IRA";
export const ROLLOVER_IRA_TEXT = "Rollover IRA";
export const BEN_ROTH_IRA_TEXT = "Beneficiary Roth IRA";
export const BEN_IRA_TEXT = "Beneficiary IRA";
export const CONVERSION_ROTH_IRA_TEXT = "Conversion Roth IRA";
export const ROLLOVER_ROTH_IRA_TEXT = "Rollover Roth IRA";

export const ROTH_IRA_ACCOUNT_TEXT_TYPES = [ROTH_IRA_TEXT, BEN_ROTH_IRA_TEXT, CONVERSION_ROTH_IRA_TEXT, ROLLOVER_ROTH_IRA_TEXT];
export const IRA_ACCOUNT_TEXT_TYPES = [IRA_TEXT, ROLLOVER_IRA_TEXT, BEN_IRA_TEXT];
export const ALL_IRA_ACCOUNT_TEXT_TYPES = [...ROTH_IRA_ACCOUNT_TEXT_TYPES, ...IRA_ACCOUNT_TEXT_TYPES];



export const MARKET_ORDER_TYPE_OPTION = { 'title':'Market', value: MARKET_ORDER_TYPE};

export const ORDER_TYPES_LIST= [ MARKET_ORDER_TYPE_OPTION, 
    {title: 'Limit', value: LIMIT_ORDER_TYPE}, 
    {title: 'Stop Loss', value: STOP_LOSS_ORDER_TYPE}, 
    {title: 'Stop Limit', value: STOP_LIMIT_ORDER_TYPE}, 
    {title: 'Take Profit Limit', value: TAKE_PROFIT_LIMIT_ORDER_TYPE}]

export const TRIGGER_PRICE_REQUIRED_ORDER_TYPES = [
    STOP_LIMIT_ORDER_TYPE,
    STOP_LOSS_ORDER_TYPE,
    TAKE_PROFIT_LIMIT_ORDER_TYPE
];

export const ORDER_TYPE_TOOLTIPS = {
  [MARKET_ORDER_TYPE]: 'Execute immediately at the current market price.',
  [LIMIT_ORDER_TYPE]: 'Buy or sell at a specific price or better.',
  [STOP_LOSS_ORDER_TYPE]: 'Triggers a market order to close a position once a specific stop price is reached.',
  [STOP_LIMIT_ORDER_TYPE]: 'Triggers a limit order once a specific stop price is reached.',
  [TAKE_PROFIT_LIMIT_ORDER_TYPE]: 'Triggers a limit order once a target price is reached.',
};

export const US_COUNTRY_IDENTIFIERS = ["United States", "US", "USA"];
